import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { ServiceOrder } from 'src/app/data/model/service-order';
import { Waypoint } from 'src/app/data/model/waypoints';
import { OdsWaypointsApiService } from 'src/app/shared/api/services/ods-waypoints-api.service';
import { ServiceOrderApiService } from 'src/app/shared/api/services/service-order-api.service';
import { UserTableVisualizationApiService } from 'src/app/shared/api/services/user-table-visualization-api.service';
import { BaseListService } from 'src/app/shared/base/base-list.service';
import { OdsWaypointsDialogComponent, WaypointsDialogParam } from '../components/ods-waypoints-dialog/ods-waypoints-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class OdsWaypointsListService extends BaseListService<
  Waypoint,
  OdsWaypointsApiService,
  WaypointsDialogParam,
  UserTableVisualizationApiService
> {
  private _ods$: BehaviorSubject<ServiceOrder | null> = new BehaviorSubject<ServiceOrder | null>(null);
  private _waypoint$: BehaviorSubject<Waypoint[] | null> = new BehaviorSubject<Waypoint[] | null>(null);

  constructor(
    dialog: MatDialog,
    apiService: OdsWaypointsApiService,
    columnService: UserTableVisualizationApiService,
    private odsService: ServiceOrderApiService
  ) {
    super(dialog, apiService, columnService);
  }

  get ods$() {
    return this._ods$.asObservable();
  }

  get waypoint$() {
    return this._waypoint$.asObservable();
  }

  loadWayPoints(odsId: number) {
    this._waypoint$.next(null);
    this.apiService.getWithFilter({service_order: odsId}).subscribe((res) => this._waypoint$.next(res.results));
  }
  loadODS(odsId: number) {
    this._ods$.next(null);
    this.odsService.get(odsId).subscribe((res) => this._ods$.next(res));
  }

  protected openDialog(
    dialogParams: WaypointsDialogParam
  ): Observable<boolean> {
    return this.dialog
      .open<
        OdsWaypointsDialogComponent,
        WaypointsDialogParam,
        boolean
      >(OdsWaypointsDialogComponent, {
        ...this.defaultDialogOptions,
        data: dialogParams,
      })
      .afterClosed()
      .pipe(map(result => result ?? false));
  }
}